const SEARCH_ENGINE_PREF_KEY = '@search_engine_preference';

export const SEARCH_ENGINES = {
    DUCKDUCKGO: {
        name: 'DuckDuckGo',
        key: 'DUCKDUCKGO',
        buildUrl: (query) => `https://duckduckgo.com/?q=${encodeURIComponent(query)}&kae=d`
    },
    QWANT: {
        name: 'Qwant',
        key: 'QWANT',
        buildUrl: (query) => `https://www.qwant.com/?q=${encodeURIComponent(query)}`
    },
    GOOGLE: {
        name: 'Google',
        key: 'GOOGLE',
        buildUrl: (query) => `https://www.google.com/search?q=${encodeURIComponent(query)}`
    },
    BING: {
        name: 'Bing',
        key: 'BING',
        buildUrl: (query) => `https://www.bing.com/search?q=${encodeURIComponent(query)}`
    },
    ECOSIA: {
        name: 'Ecosia',
        key: 'ECOSIA',
        buildUrl: (query) => `https://www.ecosia.org/search?q=${encodeURIComponent(query)}`
    },
    CHATGPT: {
        name: 'ChatGPT',
        key: 'CHATGPT',
        buildUrl: (query) => `https://chat.openai.com/?q=${encodeURIComponent(query)}`
    },
    CLAUDE: {
        name: 'Claude',
        key: 'CLAUDE',
        buildUrl: (query) => `https://claude.ai/new?q=${encodeURIComponent(query)}`
    }
};

const DEFAULT_SEARCH_ENGINE = SEARCH_ENGINES.DUCKDUCKGO;

const canUseLocalStorage = () => typeof window !== 'undefined' && Boolean(window.localStorage);

export const getStoredSearchEngine = () => {
    try {
        if (!canUseLocalStorage()) {
            return DEFAULT_SEARCH_ENGINE;
        }
        const storedEngine = window.localStorage.getItem(SEARCH_ENGINE_PREF_KEY);
        if (!storedEngine) {
            return DEFAULT_SEARCH_ENGINE;
        }
        return SEARCH_ENGINES[storedEngine] || DEFAULT_SEARCH_ENGINE;
    } catch (error) {
        console.error('Error reading search engine preference:', error);
        return DEFAULT_SEARCH_ENGINE;
    }
};

export const setDefaultSearchEngine = (engineKey) => {
    try {
        if (!SEARCH_ENGINES[engineKey]) {
            throw new Error('Invalid search engine key');
        }
        if (!canUseLocalStorage()) {
            return false;
        }
        window.localStorage.setItem(SEARCH_ENGINE_PREF_KEY, engineKey);
        return true;
    } catch (error) {
        console.error('Error saving search engine preference:', error);
        return false;
    }
};

export const getSearchUrl = (query, engine = null) => {
    try {
        const normalizedQuery = typeof query === 'string' ? query : String(query || '');
        const searchEngine = engine || getStoredSearchEngine();
        return searchEngine.buildUrl(normalizedQuery);
    } catch (error) {
        console.error('Error getting search URL:', error);
        return DEFAULT_SEARCH_ENGINE.buildUrl(query || '');
    }
};
